<template>
    <div class="container">
        <p class="content">{{ companyName }}（简称“我们”）针对“{{ appName }}”APP（简称“本应用”），依据《中华人民共和国网络安全法》、《信息安全技术个人信息安全规范》
            （GB/T 35273-2017）以及其他相关法律法规和技术规范制定《个人信息保护政策》（简称“隐私政策”）。
        </p>

        <p class="contentBlack">
            为了更好的保护您的个人信息，建议您在本应用时，仔细阅读《个人信息保护政策》，尤其是以黑色加粗的条款。如您对本隐私政策条款有任何异议或疑问，您可通过本《个人信息保护政策》第九条“联系我们”中公布的联系方式与我们沟通。
        </p>

        <p class="content">《个人信息保护政策》目录</p>
        <p class="content">一、引言</p>
        <p class="content">二、我们如何收集和使用您的个人信息</p>
        <p class="content">三、我们如何使用Cookie和同类技术</p>
        <p class="content">四、我们如何共享、转让、公开披露您的个人信息</p>
        <p class="content">五、我们如何保护您的个人信息</p>

        <p class="content">六、您的权利</p>
        <p class="content">七、我们如何存储您的个人信息</p>
        <p class="content">八、我们如何处理儿童的个人信息</p>
        <p class="content">九、联系我们</p>
        <p class="content">十、本政策如何更新</p>
        <p class="content">十一、争议解决</p>

        <p class="contentBlack">一、引言</p>
        <p class="content">1.1 《个人信息保护政策》适用于本APP向您提供的所有产品及服务。</p>
        <p class="contentBlack">1.2 请您在使用本平台各项产品和/或服务前，仔细阅读并充分理解本隐私政策的全部内容。一旦您使用或继续使用本平台的产品/服务，即表示您同意我们按照本隐私政策使用和处理您的相关信息。</p>
        <p class="contentBlack">1.3 我们可能会不时依据法律法规或业务调整对本隐私政策进行修订。当本隐私政策发生变更后，我们会在版本更新后通过在显著位置提示或推送通知、消息等形式向您展示变更后的内容。</p>
        <p class="contentBlack">1.4 您需理解，只有在您确认并同意变更后的《个人信息保护政策》，我们才会依据变更后的隐私政策收集、使用、处理和存储您的个人信息；您有权拒绝同意变更后的隐私政策，但请您知悉，一旦您拒绝同意变更后的隐私政策，
            可能导致您不能或不能继续完整使用本平台的相关服务和功能，或者无法达到我们拟达到的服务效果。</p>


        <p class="contentBlack">二、我们如何收集和使用您的个人信息</p>
        <p class="content">2.1 我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目
            的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保 护措施来保护您的个人信息。
            如果我们欲将您的个人信息用于本隐私政策未载明的其它用途，或基于特定目的将收集而来的信息用于其他目的，我们会及时以合理的 方式向您告知，并在使用前再次征得您的同意。</p>
        <p class="contentBlack">2.2 个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本隐私政策中涉及的个人信息
            包括：基本信息（包括个人姓名、生日、性别、个人电话号码）；个人身份信息（包括身份证、户口本）；生物识别特征（静态或动态的面部特征）；网络身份标识 信息（包括账号、IP地址及与前述有关的密码）；个人上网记录（
            包括网站浏览记录、软件使用记录、点击记录）；个人常用设备信息（包括设备名称、设备型 号、操作系统和应用程序版本、设备设置、设备MAC地址、唯一设备标识符、设备环境、应用信息列表等软硬件特征信息）；个人位置信息
            （包括精准定位信息、 经纬度以及WLAN接入点等传感器信息等）； 个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，本隐私政策中涉及的个
            人敏感信息包括：您的生物识别特征（静态或动态的面部特征）；个人身份信息（包括身份证、驾驶证、户口本）；网络身份识别信息（包括账户名、账户昵称、及 与前述有关的密码与密码保护问题和答案）；其他信息
            （包括手机号码、网页浏览记录、精准定位信息）。</p>
        <p class="content">2.3 通常情况下，我们会会出于以下目的收集和使用您的个人信息：</p>
        <p class="content">2.3.1【注册】当您注册本平台账号时，我们会收集您的昵称、性别、出生年月日、工作地区、身高、学历、月收入区间、婚姻状况信息、手机号码，收集这些信息是为了帮助您完成本平台注册，建立您的征婚档案。
            手机号码属于个人敏感信息，收集此类信息是为了满足相关法律法规的网络实名制要求，若您不提供这类信息，您可能无法正常使用我们的服务。在使用服务过程中，如果您提供以下额外信息补全个人资料，
            将有助于我们给您提供更好的服务和体验：您的籍贯、家乡、职业、学校、您本人的真实头像等。但如果 您不提供这些信息，将不会影响使用我们产品或服务的基本功能。您提供的上述信息将在您使用本服务期间持续授权我们使用。
            当您注册或者找回密码时您需要相应 开启短信自动读取短信的权限，如果您拒绝/取消提供，您将无法使用短信自动读取功能，同时，您也可以随时通过您设备的相关功能设置开启/取消该权限。</p>
        <p class="content">2.3.2【信息发布及分享】当您上传头像、使用动态及其他信息发布功能公开发布信息，包括发布图片、短视频时，您需要相应开启摄像头、相册、存储权限。同时，您也可以随时通过您设备的相关功能设置开启/取消该权限。
            当您取消该授权后，我们无法再为您提供上述与之对应的服务。您上传的动态照片、短视频、评论、点赞等信息会存储在我们的服务器中，因为存储是实现这一功能所必需的。我们会以加密的方式存储，您也可以随时删除这些信息。
            除非经您自主选择或遵从相关法律法规要求，我们不会对外提供上述动态信息，或者将其用于该功能以外的其他用途。您在使用我们的产品/服务（譬如动态、情侣空间等）分享信息至其他平台时，你需要相应开启获取应用账户权限，
            如您拒绝开启，您将无法使用信息分享功能。</p>

        <p class="content">特别提示：您公开发布的信息中可能会涉及您或他人的个人信息甚至个人敏感信息，如您在发布动态时选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。</p>
        <p class="content">2.3.3【语音聊天】当您使用语音聊天相关服务时（例如：蜜语、消息里发送语音内容），您需要相应开启麦克风、存储权限来进行语音交互。开启手机存储权限是实现这一功能所必需的。同时，
            您也可以随时通过您设备的相关功能设置开启/取消该权限。当您取消该授权后，我们将无法再为您提供上述与之对应的服务。</p>
        <p class="content">2.3.4【位置】当您进行账号注册、查看附近的人、附近动态，消息界面查看您与对方的距离时，我们会在获得您的自主选择同意开启位置权限后，记录您的地理位置信息。该信息属于个人敏感信息，
            拒绝提供该信息会使您无法使用上述功能，但不影响您正常使用本平台的其他功能。此外，您可以随时通过您设备的相关功能设置开启/取消该权限。</p>
        <p class="content">2.3.5【支付】当您在本平台上开通会员服务、购买礼物、购买星级特权等发生支付行为时，需要使用到支付功能。在支付过程中， 我们可能会收集您的第三方支付渠道的user ID 
            (例如支付宝user ID、微信open ID、QQ钱包open ID或银行卡信息)（个人敏感信息）。上述信息为我们向您提供您购买商品和/或服务所必须的信息，我们无法仅根据该信息获得您的个人财产信息，也不能识别特定自然人身份信息。</p>
        <p class="content">2.3.6【认证】当您使用实名认证、人脸认证、学历认证、信用认证、车辆认证、房屋认证、开通居民身份证网上功能凭证（简称“网证”）时，我们将会收集您的手机号码、姓名、身份证号码、学历信息、职业信息、
            房屋信息、车辆信息，上述信息属于个人敏感信息，如您拒绝提供上述信息，您可能无法完成上述认证，但不影响您正常使用本平台的其他功能，您也可以通过注销账户功能随时自助删除个人认证信息或者通过联系人
            工客服协助处理删除个人认证信息。</p>

        <p class="content">2.3.7 【第三方获取】若我们从第三方处间接获取您的信息的，我们会在收集前明确以书面形式要求该第三方在已依法取得您同意后收集个人信息，并向您告知共享的信息内容，且涉及敏感
            信息的在提供给我们使用前需经过您的明确确认，要求第三方对个人信息来源的合法性和合规性作出承诺，如第三方有违反行为的，我们会明确要求对方承担相应法 律责任；同时，我们的专业安全团队对个人信息会进行安全防护
            （包括敏感信息分级分类、敏感信息使用的访问控制、敏感信息加密存储等）。我们会使用不低于我 们对自身用户个人信息同等的保护手段与措施对间接获取的个人信息进行保护。</p>
        <p class="content">2.3.8【推荐服务】我们会基于收集的信息，进行综合统计并通过算法做特征与偏好分析，用以向你进行个性化推荐、展示或推送你可能感兴趣的特定内容等信息，或者推送更合适你的特
            定功能或服务，例如向您展现或推荐相关程度更高（而非普遍推送）的用户，以帮助您找到更合适的相亲对象；为此，我们需要收集的信息包括您的服务日志信息、 浏览偏好、点赞/分享/评论/互动/关注的信息、搜索的字词、
            学历、位置（个人敏感信息）。</p>

         <p class="content">特别提示：我们可能会收集您使用我们的产品与/或服务时的搜索记录、浏览记录、赠送礼物信息、设备信息、点赞/分享/评论/互动的对象、您的偏向网络行为、 兴趣偏好等信息形成用户画像用于
             帮助使我们更加了解您如何接入和使用我们的产品与/或服务、维护和改进我们的产品与/或服务或对您作出其他方面的回应。我们收集、使用上述信息时进行了去标识化处理，数据分析仅对应特定的、无法直接关联用户身份的编码，
             无法也绝不会与你的真实身份相关联。</p>
        <p class="content">2.3.9【提供优质服务】为了保证向您提供及时、优质的婚介服务，您同意我们您提供的电话、手机、电子邮箱拨打电话或发送短信及邮件（内容包括但不限于服务流程确认，告知您其他会员
            希望与您联系、约见，活动信息和资讯、新服务或新产品的推介等，提示再次登录本网站等），您同意开启麦克风权限来与我们进行电话、手机沟通。您也可以主动 联系我们的红娘希望我们提供婚介服务，进行此项操作时，
            您可能需要相应的开启麦克风、拨打电话权限来与我们沟通。</p>
        <p class="content">2.3.10【客服支持】当您向本平台发起投诉、申诉或进行咨询时，为了您的账号与系统安全，我们可能需要您先行提供账号信息，并与您之前的个人信息相匹配以验证您的用户身份。同时，
            为了方便与您联系或帮助您解决问题，我们可能还需要您提供姓名、手机号码、电子邮件及其他联系方式等个人信息（个人敏感信息）。另 外，我们还会收集您与我们的沟通信息（包括文字/图片/音视频/通话记录形式）、
            与您的需求相关联的其他必要信息。我们收集这些信息是为了调查事实与帮助 您解决问题，如您拒绝提供上述信息，我们可能无法向您及时反馈投诉、申诉或咨询结果。在进行投诉、申诉或进行咨询时，您可能需要相应的开启相册、
            相机、麦 克风、拨打电话权限来与客服沟通并提供相应材料。当然，您也可以随时通过您设备的相关功能设置开启/取消该权限。</p>
        <p class="content">2.3.11【安全支持】为提高您使用我们产品/服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，
            更准确地识别违反法律法规或本平台相关协议规则的情况，我们可能使用或整合您的用户信息、交易信息、设备信息、有关网络日志以及我们合作伙伴取得您授权或依据法律共享给我们的信息，来综合判断您账户及交易风险、进行身份验证、
            检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。</p>
        <p class="content">2.3.12 您在升级我们的移动客户端（“APP”）或者点击我们产品或服务中的第三方广告信息时，可能会需要您开启安装应用的权限，如果您拒绝开启，
            您可能无法完成我们的APP升级或使用第三方的产品或者服务。</p>


        <p class="content">2.3.13 您理解并同意，我们提供的产品/服务可能需要您在您的设备中开启您的位置信息、相机、相册、麦克风、悬浮窗、获取应用账户、拨打电话、接受/读取短信的访 问权限，
            以实现这些权限所涉及信息的收集和使用。我们会在您使用相关服务时弹窗提示您是否要开启相应权限。您可在您的设备设置查看上述权限的状态，并可自 行决定这些权限随时的开启或关闭。请您注意，
            您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您 取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，
            您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用,您可以随时通过您设备的相关功能设置开启/取消该权限。</p>
        <p class="contentBlack">以下是详细具体相关权限获取使用目的、方式、范围说明（以下权限可以通过您设备的相关功能设置开启/取消该权限）：</p>

        <p class="contentBlack">获取权限名称：电话 CALL_PHONE</p>
        <span class="content">描述：拨打电话</span>
        <span class="content">对应功能：应用于使用一键登录功能</span>

        <p class="contentBlack">获取权限名称：储存空间 WRITE_EXTERNAL_STORAGE</p>
        <span class="content">描述：修改或删除您sd卡中的内容</span>
        <span class="content">对应功能：应用于版本更新、相册功能、拍照、上传视频</span>

        <p class="contentBlack">获取权限名称：位置信息 ACCESS_FINE_LOCATION</p>
        <span class="content">描述：访问确切位置信息（以gps或网络为依据）</span>
        <span class="content">对应功能：应用于推荐官功能，获取地理位置信息推荐</span>

        <p class="contentBlack">获取权限名称：位置信息 ACCESS_COARSE_LOCATION</p>
        <span class="content">描述：访问大致位置信息（以网络为依据）</span>
        <span class="content">对应功能：应用于推荐官功能，获取地理位置信息推荐</span>

        <p class="contentBlack">获取权限名称：麦克风 RECORD_AUDIO</p>
        <span class="content">描述：录音</span>
        <span class="content">对应功能：应用拍摄个人视频上传功能需要</span>


        <p class="contentBlack">获取权限名称：相机 CAMERA</p>
        <span class="content">描述：拍摄照片和视频</span>
        <span class="content">对应功能：应用于个人相册图片上传需要</span>

        <p class="contentBlack">获取权限名称：储存空间 READ_EXTERNAL_STORAGE</p>
        <span class="content">描述：读取您的sd卡中的内容</span>
        <span class="content">对应功能：应用于版本更新、相册功能、拍照、上传视频</span>

        <p class="contentBlack">获取权限名称：电话 READ_PHONE_STATE</p>
        <span class="content">描述：读取手机状态和身份</span>
        <span class="content">对应功能：应用于使用一键登陆功能</span>



        <p class="content">2.3.15 我们向你提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了你的信息，我们会通过页面提示、交互流程、网站公告等方式另行向你说明信息收集的内容、范围和目的，
            以征得你的同意。</p>
        <span class="content">另外，根据相关法律法规及国家标准，在以下情况下，我们无需取得您的授权同意即可收集和使用您的个人信息：</span>
        <span class="content">1) 与国家安全、国防安全等国家利益直接相关的；与公共安全、公共卫生、公众知情等重大公共利益直接相关的；</span>
        <span class="content">2) 与犯罪侦查、起诉、审判和判决执行等直接相关的；</span>
        <span class="content">3) 出于维护你或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；</span>
        <span class="content">4) 所收集的个人信息是你自行向社会公众公开的；</span>
        <span class="content">5) 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</span>
        <span class="content">6) 根据你要求签订和履行合同所必需的；</span>
        <span class="content">7) 用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</span>
        <span class="content">8) 为开展合法的新闻报道所必需的；</span>
        <span class="content">9) 出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</span>
        <span class="content">10) 法律法规规定的其他情形。</span>


        <p class="contentBlack">三、我们如何使用Cookie和同类技术</p>
        <p class="content">3.1 Cookie</p>
        <p class="content">为确保网站正常运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、
            站点名称以及一些号码和字符。借助于 Cookie，网站能够存储您的偏好等数据。</p>
        <p class="content">3.2网站信标和像素标签</p>
        <p class="content">除 Cookie 外，我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，
            帮助我们了解您的产品或服务偏好以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子 邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，
            则可以随时从我们的寄信名单中退订。</p>
        <p class="content">3.3 SDK技术</p>
        <p class="content">SDK技术由与我们合作的第三方机构提供，我们仅能知悉其要求获得授权的权限。第三方机构将会需要收集您的信息，我们无法获取您的信息，除非第三方机构明确向我们披露的要收集的敏感信息。</p>
        <p class="content">在为安卓系统的用户提供服务时，我们将使用下列SDK技术，所需要的功能和第三方要收集的用户信息为：</p>

        <p class="contentBlack">第三方SDK名称：“友盟”SDK</p>
        <span class="content">用途与目的：统计线上crash、anr异常，进行数据统计</span>
        <span class="content">调用权限和获取方式：存储权限、读取设备信息、读取网络状态、读取WIFI状态</span>
        <span class="content">收集的个人信息类型：设备信息（IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://www.umeng.com/page/policy">https://www.umeng.com/page/policy</a></span>

        <p class="contentBlack">第三方SDK名称：“创蓝一键登录”的SDK</p>
        <span class="content">用途与目的：一键注册登陆</span>
        <span class="content">调用权限和获取方式：读取网络状态、读取WIFI状态、读取设备信息、访问网络、读写系统设置、访问TASK</span>
        <span class="content">收集的个人信息类型：设备信息、手机IMSI、电话号码</span>
        <span class="content">提供SDK的公司官网链接：<a href="http://shanyan.253.com/">http://shanyan.253.com/</a></span>

        <p class="contentBlack">第三方SDK名称：“支付宝实名认证”的SDK</p>
        <span class="content">用途与目的：对用户进行人脸实名认证</span>
        <span class="content">调用权限和获取方式：存储权限、相机权限</span>
        <span class="content">收集的个人信息类型：个人身份信息、面部识别特征</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://cn.aliyun.com/product/cloudauth">https://cn.aliyun.com/product/cloudauth</a></span>

        <p class="contentBlack">第三方SDK名称：“微信支付”的SDK</p>
        <span class="content">用途与目的：帮助用户在应用内使用微信支付</span>
        <span class="content">调用权限和获取方式：读取设备信息、读取网络状态、读取WIFI状态</span>
        <span class="content">收集的个人信息类型：设备标识信息、网络信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://pay.weixin.qq.com/">https://pay.weixin.qq.com/</a></span>

        <p class="contentBlack">第三方SDK名称：Alipay（支付宝） SDK</p>
        <span class="content">用途与目的：帮助用户在应用内使用支付宝支付</span>
        <span class="content">调用权限和获取方式：读取设备信息、读取网络状态、读取WIFI状态</span>
        <span class="content">收集的个人信息类型：设备标识信息、网络信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://docs.open.alipay.com/">https://docs.open.alipay.com/</a></span>

        <p class="contentBlack">第三方SDK名称：“FaceUnity”相芯科技的SDK</p>
        <span class="content">用途与目的：提供用户在应用内对头像进行美颜的功能</span>
        <span class="content">调用权限和获取方式：相机权限、存储权限</span>
        <span class="content">收集的个人信息类型：无</span>
        <span class="content">提供SDK的公司官网链接：<a href="http://www.faceunity.com/">http://www.faceunity.com/</a></span>

        <p class="contentBlack">第三方SDK名称：“OPPO push”SDK</p>
        <span class="content">用途与目的：向OPPO手机用户推送消息陆</span>
        <span class="content">调用权限和获取方式：存储权限、读取设备信息、读取网络状态、读取WIFI状态</span>
        <span class="content">收集的个人信息类型：设备标识信息、网络信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://open.oppomobile.com/wiki/doctid=10196">https://open.oppomobile.com/wiki/doctid=10196</a></span>

        <p class="contentBlack">第三方SDK名称：“VIVO push”SDK</p>
        <span class="content">用途与目的：向VIVO手机用户推送消息</span>
        <span class="content">调用权限和获取方式：存储权限、读取设备信息、读取网络状态、读取WIFI状态</span>
        <span class="content">收集的个人信息类型：设备标识信息、网络信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://dev.vivo.com.cn/home">https://dev.vivo.com.cn/home</a></span>

        <p class="contentBlack">第三方SDK名称：“小米push”SDK</p>
        <span class="content">用途与目的：向用户推送消息</span>
        <span class="content">调用权限和获取方式：存储权限、读取设备信息、读取网络状态、读取WIFI状态</span>
        <span class="content">收集的个人信息类型：设备标识信息、网络信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://dev.mi.com/console/appservice/push.html">https://dev.mi.com/console/appservice/push.html</a></span>

        <p class="contentBlack">第三方SDK名称：“华为push”的SDK</p>
        <span class="content">用途与目的：向用户推送消息</span>
        <span class="content">调用权限和获取方式：存储权限、读取设备信息、读取网络状态、读取WIFI状态</span>
        <span class="content">收集的个人信息类型：设备标识信息、网络信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://developer.huawei.com/consumer/cn/service/hms/pushservice.html">https://developer.huawei.com/</a></span>

        <p class="contentBlack">第三方SDK名称：“阿里push”的SDK</p>
        <span class="content">用途与目的：向用户推送消息</span>
        <span class="content">调用权限和获取方式：存储权限、读取设备信息、读取网络状态、读取WIFI状态</span>
        <span class="content">收集的个人信息类型：设备标识信息、网络信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://open.1688.com/">https://open.1688.com/</a></span>

        <p class="contentBlack">第三方SDK名称：“魅族push”的SDK</p>
        <span class="content">用途与目的：向用户推送消息</span>
        <span class="content">调用权限和获取方式：存储权限、读取设备信息、读取网络状态、读取WIFI状态</span>
        <span class="content">收集的个人信息类型：设备标识信息、网络信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="http://open.flyme.cn/">http://open.flyme.cn/</a></span>

        <p class="contentBlack">第三方SDK名称：“阿里push”的SDK</p>
        <span class="content">用途与目的：向用户推送消息</span>
        <span class="content">调用权限和获取方式：存储权限、读取设备信息、读取网络状态、读取WIFI状态</span>
        <span class="content">收集的个人信息类型：设备标识信息、网络信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://open.1688.com/">https://open.1688.com/</a></span>

        <p class="contentBlack">第三方SDK名称：“融云”的SDK</p>
        <span class="content">用途与目的：给应用内的用户提供IM聊天的功能</span>
        <span class="content">调用权限和获取方式：存储权限、读取设备信息、读取网络状态、读取WIFI状态、呼吸灯权限、振动器权限、相机权限、录音权限</span>
        <span class="content">收集的个人信息类型：设备标识信息、网络信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://www.rongcloud.cn/">https://www.rongcloud.cn/</a></span>

        <p class="contentBlack">第三方SDK名称：“百度文字识别”的SDK</p>
        <span class="content">用途与目的：给应用内用户提供图片文字识别功能</span>
        <span class="content">调用权限和获取方式：存储权限、读取网络状态、相机权限</span>
        <span class="content">收集的个人信息类型：网络信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://ai.baidu.com/">https://ai.baidu.com/</a></span>

        <p class="contentBlack">第三方SDK名称：“腾讯TRTC 音视频”SDK</p>
        <span class="content">用途与目的：给应用内用户提供音视频通话服务</span>
        <span class="content">调用权限和获取方式：存储权限、读取网络状态、相机权限</span>
        <span class="content">收集的个人信息类型：网络信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://cloud.tencent.com/product/trtc">https://cloud.tencent.com/product/trtc</a></span>

        <p class="contentBlack">第三方SDK名称：“图谱智能鉴黄”SDK</p>
        <span class="content">用途与目的：用于将应用内用户产生的不良信息进行过滤</span>
        <span class="content">调用权限和获取方式：存储权限、读取网络状态、相机权限</span>
        <span class="content">收集的个人信息类型：无</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://www.tuputech.com/">https://www.tuputech.com/</a></span>

        

        <p class="contentBlack">同时，我们使用了其他不需要获取权限，也不需要获取用户信息的SDK，包括：</p>
        <span class="content">1) AndPermission SDK（用于询问权限的框架工具，本身不需权限）；</span>
        <span class="content">2) BlankjUtilCode SDK（用于提高开发效率）；</span>
        <span class="content">3) 阿里云播放 SDK（用于播放视频）；</span>
        <span class="content">4) 移动安全联盟 SDK(用于规范标识移动设备）</span>
        <span class="content">5）北京提子科技SDK（即135编辑器，用于应用内发布h5文章时，对文章内容进行排版处理并存放文章内所展示的图片，排版处理完成之后，用于应用内展示相关文章内容）；</span>
        <span class="content">6）“React Native”的SDK（com.facebook 开头的进程），用于将编写的js 代码编程器成原生可识别的java 代码和Objective-C 代码，进行跨平台开发。</span>

        <p class="content">3.4保障产品与服务的安全、高效运转</p>
        <p class="content">如果您拒绝我们使用Cookie及同类技术收集和使用您的相关信息，您可在浏览器具备该功能的前提下，通过您的浏览器的设置以管理、
            （部分/全部）拒绝 Cookie与/或同类技术；或删除已经储存在您的计算机、移动设备或其他装置内的Cookie与/或同类技术，从而实现我们无法全部或部分追踪您的个人 信息。您如需详细了解如何更改浏览器设置，
            请具体查看您使用的浏览器的相关设置页面。您理解并知悉：我们的某些产品/服务只能通过使用Cookie或同类 技术才可得到实现，如您拒绝使用或删除的，您可能将无法正常使用我们的相关产品与/或服务或无法通过我们
            的产品与/或服务获得最佳的服务体验，同时也可能 会对您的信息保护和账号安全性造成一定的影响。</p>
        
        <p class="contentBlack">四、我们如何共享、转让、公开披露您的个人信息</p>
        <p class="content">4.1 共享</p>
        <p class="content">4.1.1 您的个人信息可能会在我们的关联公司之间共享。我们只会共享必要的个人信息（如为便于您使用本平台账号使用关联公司的其他产品或服务，识别账号异常或保护本平台关联公司或其他用户或公众的人身财产
            安全免遭侵害，我们会在关联公司内共享您必要的账户信息）且会受本隐私群政策中所声明目的的约束，如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。</p>
        <p class="content">4.1.2 为了向您提供更完善、优质的产品和服务，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确
            的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。同时，我们会与合作伙伴签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密
            和安全措施来处理您的个人信息。我们的合作伙伴无权 将共享的个人信息用于任何其他用途。如果您拒绝我们的合作伙伴在提供服务时收集为提供服务所必须的个人信息，将可能导致您无法在我们的平台中使用该第三方 服务。</p>
        <p class="content">4.2 转让</p>
        <p class="content">我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
        <p class="content">4.2.1 在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</p>
        <p class="content">4.2.2 在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</p>
        <p class="content">4.3 公开披露</p>
        <p class="content">我们仅会在以下情况下，公开披露您的个人信息：</p>
        <span class="content">1）获得您明确同意后；</span>
        <span class="content">2）基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</span>
        <span class="content">3）因需要对违规账号、欺诈行为等进行处罚公告的。特别提示：对于公开披露的您的个人信息，我们会在收到公开披露申请后第一时间且审慎审查其正当性、合理性、合法性，
            并在公开披露时和公开披露后采取最严格个人信息安全保护措施和手段对其进行保护。</span>

        <p class="content">4.4 共享、转让、公开披露您的个人信息的例外</p>
        <p class="content">请您知悉，另外，根据相关法律法规及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息无需事先征得个人信息主体的授权同意：</p>
        <span class="content">1） 与国家安全、国防安全直接相关的；</span>
        <span class="content">2） 与公共安全、公共卫生、重大公共利益直接相关的；</span>
        <span class="content">3） 与犯罪侦查、起诉、审判和判决执行等直接相关的；</span>
        <span class="content">4） 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的</span>
        <span class="content">5） 个人信息主体自行向社会公众公开的个人信息；</span>
        <span class="content">6） 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道</span>
        <p class="content">根据法律规定， 若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意。</p>

         <p class="contentBlack">五、我们如何保护您的个人信息</p>
         <p class="content">5.1 我们使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权的访问、公开披露、使用、修改，防止数据发生损坏或丢失。我们将在合理的 安全水平内使用各种安全保护措施以保障信息的安全。
             例如，我们会使用加密技术（例如，SSL）、匿名化处理等手段来保护你的个人信息。我们已建立访问控制 机制，确保只有授权人员才可以访问个人信息；我们不时的举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</p>
         <p class="content">5.2 我们通过不断提升的技术手段加强安装在你设备端的软件的安全能力，以防止你的个人信息泄露。例如，我们为了安全传输会在你设备本地完成部分信息加密的工作；为了预防病毒、木马程序或其他恶意程序、
             网站会了解你设备安装的应用信息或正在运行的进程信息</p>
         <p class="content">5.3 我们建立专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。</p>
         <p class="content">5.4 若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知你。</p>
         <p class="content">5.5 我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</p>
         <p class="content">5.6 互联网并非绝对安全的环境，因此，我们强烈建议你采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等个人信息透露给他人。
             如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络本平台客服，以便我们根据您的申请采取相应措施。</p>
         <p class="content">5.7 互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您 告知：安全事件的基本情况和可能的影响、
             我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以 邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。
             同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>

         <p class="contentBlack">六、您的权利</p>    
         <p class="content">我们理解您对个人信息的关注，为了你可以更加便捷地访问、更正、补充、删除您的个人信息，同时保障你撤回对个人信息使用的同意及注销账号的权利，我们在产品设计中为你提供了相应的操作设置，
             你可以参考下面的指引进行操作。此外，我们还设置了投诉举报渠道，你的意见将会得到及时的处理。</p>
         <p class="content">6.1 访问、更正和补充您的个人信息</p>
         <p class="content">访问、更正和补充头像、我的相册、我的动态、个人证件信息、基本条件、择偶条件等基本信息：</p>
         <p class="content">登录账号后，点击“我的”模块后点击头像，进行信息访问、更正和补充。</p>
         <p class="content">6.2 访问、更正手机号、登录密码等账户信息</p>
         <p class="content">登录账号后，点击“我”；点击“设置”，进行信息访问、更正。</p>
         <p class="content">如果您无法通过上述路径访问该等个人信息，您可以随时通过本隐私政策第九条“联系我们”取得联系。本平台将在14个工作日内回复您的访问请求。</p>
         <p class="content">对于您在行使上述权利过程中遇到的困难，或者其他可能目前无法向您提供在线自行更正/修改服务的，经过对您身份的验证，且更正/修改不影响信息的客观性和准确性的情况下，您有权对错误或不完整的信息作出更正或修改，
             或在特定情况下，尤其是数据错误时，通 过我们公布的反馈与报错等措施将您的更正/修改申请提交给我们，要求我们更正或修改您的数据，但法律法规另有规定的除外。但出于安全性和身份识别的考虑，
             您可能无法修改注册时提交的某些初始注册信息。</p>
         <p class="content">6.3 注销并删除您的个人信息</p>
         <p class="content">登录账号后，点击“我的”-“设置”-“注销账号”，注销并删除个人信息。</p>
         <p class="content">在以下情形中，您可以向我们提出删除个人信息的请求：</p>
         <span class="content">1）如果我们处理个人信息的行为违反法律法规；</span>
         <span class="content">2）如果我们收集、使用您的个人信息，却未征得您的明确同意；</span>
         <span class="content">3）如果我们处理个人信息的行为严重违反了与您的约定；</span>
         <span class="content">4）如果您不再使用我们的产品或服务，或您主动注销了账号；</span>
         <span class="content">5）如果我们永久不再为您提供产品或服务。</span>
         <p class="content">若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，要求其及时删除，除非法律法规另有规定，或这些主体获得您的独立授权。</p>
         <p class="content">当您或我们协助您从我们的服务中删除信息后，依据相关法律法规的规定，我们可能不会立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。</p>
         <p class="content">6.4 投诉举报</p>
         <p class="content">登录账号后，点击“我”，点击“设置”，点击“意见反馈”。</p>
         <p class="content">6.5 访问隐私政策</p>
         <p class="content">APP端：您可以在注册页面，或者登录账号后，点击“我”，点击“关于”，点击“隐私政策”。</p>
         <p class="content">6.6 撤回您对个人信息的同意</p>
         <p class="content">我们提供的产品和服务的部分功能需要获得您使用设备的相关权限（包括：位置、相册、相机、麦克风等，具体以产品实际获取的功能为准）。您可以在授权后随时撤回（或停止）对该权限的继续授权。您需理解，
             当您撤回授权后，我们无法继续为您提供撤回授权所对应的特定功能和/或服务。但您撤回授权的决定，不会影响此前基于您的授权而开展的个人信息处理</p>
         <p class="content">6.7 响应您的上述请求</p>
         <p class="content">为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</p>
         <p class="content">我们将在14个工作日内做出答复。如您不满意，还可以通过本平台客 服发起投诉。 对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、
             需要过多技术手段（例如， 需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</p>
         <p class="content">在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
         <span class="content">1）与国家安全、国防安全有关的；</span>
         <span class="content">2）与公共安全、公共卫生、重大公共利益有关的；</span>
         <span class="content">3）与犯罪侦查、起诉、审判和执行判决等有关的；</span>
         <span class="content">4）有充分证据表明个人信息主体存在主观恶意或滥用权利的；</span>
         <span class="content">5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；。</span>
         <span class="content">6）涉及商业秘密的。</span>


         <p class="contentBlack">七、我们如何存储您的个人信息</p>         
         <p class="content">7.1信息存储的地点</p>
         <p class="content">我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内。</p>
         <p class="content">7.2信息存储的期限</p>
         <p class="content">一般而言，我们在您使用服务时获取到您个人信息内会进行存储，并在您注销本平台账户后合理期限内删除或进行匿名化处理。</p>
         <p class="content">当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。</p>

         
         <p class="contentBlack">八、我们如何处理儿童的个人信息</p>
         <p class="contentBlack">只有年满18周岁，具有完全民事行为能力的单身人士才可以注册。本平台不会向未成年人推销自己，或者未经父母同意而有意收集其未成年子女的个人信息。</p>


         <p class="contentBlack">九、联系我们</p>
         <p class="content">9.1如您对《个人信息保护政策》的内容或使用我们的服务时遇到的与隐私保护相关的事宜有任何疑问或进行咨询或投诉时，您均可以通过如下任一方式与我们取得联系：</p>
         <span class="content">1）您可找到我们平台上产品功能页面中在线客服或者在线提交反馈意见与我们联系；</span>
         <!-- <span class="content">2）您可以拨打客服电话{{ companyPhone }}与我们联系；</span> -->
         <span class="content">2）您可以发送邮件至：{{ companyMail }}</span>
         <p class="content">9.2我们会在收到您的意见及建议后，并在验证您的用户身份后的14个工作日内尽快向您回复。此外，您理解并知悉，在与个人信息有关的如下情形下，我们将无法回复您的请求：</p>
         <span class="content">1）与国家安全、国防安全有关的；</span>
         <span class="content">2）与公共安全、公共卫生、重大公共利益有关的；</span>
         <span class="content">3）与犯罪侦查、起诉和审判等有关的；</span>
         <span class="content">4）有充分证据表明您存在主观恶意或滥用权利的；</span>
         <span class="content">5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</span>
         <span class="content">6）涉及商业秘密的；</span>
         <span class="content">7）法律法规等规定的其他情形。</span>

         <p class="contentBlack">十、本政策如何更新</p>
         <p class="content">10.1 为了给您提供更好的服务，我们会根据产品的更新情况及法律法规的相关要求更新《个人信息保护政策》的条款，该等更新构成《个人信息保护政策》的一部分。未经您明确同意，
             我们不会削减您按照本政策所应享有的权利。如该等更新造成您在本《个人信息保护政策》下权利的实质减少或重大变更，我们将在本政策生效前通过在显著位置提示或向您发送推送消息或以其他方式通知您，
             若您继续使用我们的服务，即表示您充分阅读、理解并同意受经修订的《个人信息保护政策》的约束</p>
         <p class="content">10.2 重大变更包括但不限于：</p>
         <span class="content">1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</span>
         <span class="content">2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</span>
         <span class="content">3）个人信息共享、转让或公开披露的主要对象发生变化；</span>
         <span class="content">4）您参与个人信息处理方面的权利及其行使方式发生重大变化；</span>
         <span class="content">5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；</span>
         <span class="content">6）个人信息安全影响评估报告表明存在高风险时。</span>

         <p class="contentBlack">十一、争议解决</p>
         <p class="content">11.1 本隐私政策的解释及争议解决均应适用中华人民共和国大陆地区法律。任何因本隐私政策以及我们处理您个人信息事宜引起的争议，您同意向当地人民法院提起诉讼来寻求解决方案。</p>
         <p class="content">11.2 如果您认为我们处理个人信息的行为损害了您的合法权益，您也可以选择向有关政府部门进行反映。</p>

         <p class="content">注：《个人信息保护政策》版本更新日期为2020年12月24日，将于2020年12月24日正式生效。</p>



    </div>
</template>

<script>
export default {
    data() {
        return {
            appName: '陌生交友聊天',
            companyName: '合肥来聊网络科技有限公司',

            companyMail: 'support@haimao.tech',
            companyPhone: '020-82081873',
        }
    },

    created() {
        document.title = '隐私协议';
        const url = window.location.href;
        const paramsStr = url.split('?')[1];
        const paramsArr = paramsStr.split('&');
        paramsArr.forEach((item) => {
            const t = item.split('=');
            if (t[0] == 'companyName') this.companyName = decodeURI(t[1]);
            if (t[0] == 'appName') this.appName = decodeURI(t[1]);
            if (t[0] == 'companyPhone') this.companyPhone = decodeURI(t[1]);
            if (t[0] == 'companyMail') this.companyMail = decodeURI(t[1]);
        })
    }
}
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
    background-color: #FFF;
}

.content {
    font-size: 12px;
    color: #666;
}
.contentBlack {
    font-size: 12px;
    color: #000;
    font-weight: 600;
}
</style>